import React from 'react';
import { noop } from 'lodash';

import { RegisterOpenModalOptions, RegisterShortcutOptions } from './types';

type KeyboardShortcutsContext = {
  registerShortcut: (
    shortcut: string,
    callback: (event: KeyboardEvent) => void | (() => void),
    options?: RegisterShortcutOptions,
  ) => () => void;
  registerOpenModal: (id: string, options?: RegisterOpenModalOptions) => () => void;
};

export const KeyboardShortcutContext = React.createContext<KeyboardShortcutsContext>({
  registerShortcut: () => {
    throw new Error('KeyboardShortcutsContext is not initialized');
  },
  registerOpenModal: () => noop,
});
